import { Typography } from "@mui/material";
import React, { Fragment } from "react";
import AddIco from "../../../../assets/icons/AddIco";
import EditInfoIco from "../../../../assets/icons/EditInfoIco";
import QuestionMarkIco from "../../../../assets/icons/QuestionMarkIco";
import CommonButton from "../../../../component/Button";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomPaper } from "../../../resume-intelligence/Style";
import { CustomOrderList } from "../../style";
import TickTalairoIco from "../../../../assets/icons/TickTalairoIco";

export default function PreScreenQuestions({
  matchedData,
  resumeLoader,
  enableQuestion,
  handleQuestionEnable,
  handlePreScreenQuestionEdit,
}) {
  const check_validation =
    matchedData?.insights?.feedback?.pre_screen_questions_red_flags &&
    matchedData?.insights?.feedback?.pre_screen_questions_red_flags?.length !==
      0;
  return (
    <Fragment>
      <CustomPaper
        variant="outlined"
        width="100%"
        padding={"12px"}
        display={"flex"}
        alignItems={"start"}
        gap="1rem"
        background="#F7F8F9"
        margin="1rem 0px 0px"
      >
        <CustomDiv margin="4px 0px 0px">
          <QuestionMarkIco />
        </CustomDiv>
        <CustomDiv width="100%">
          <CommonGrid2
            display={"flex"}
            flexWrap={"wrap"}
            gap={"1rem"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography variant="h5" fontWeight={600}>
              {"Recommended Pre-screen questions :"}
            </Typography>

            {matchedData?.status !== "Rejected" && (
              <CommonGrid2
                display={"flex"}
                flexWrap={"wrap"}
                gap={"1rem"}
                alignItems={"center"}
              >
                {resumeLoader ? (
                  <HandleSkeletion
                    width="100px"
                    height="30px"
                    transform="scale(1)"
                  />
                ) : check_validation ? (
                  <Fragment>
                    <CommonButton
                      variant="outlined"
                      color="#344054"
                      border="transparent"
                      startIcon={<EditInfoIco />}
                      fontWeight="600"
                      value={"Manage"}
                      gap={"0px"}
                      padding={"4px 1rem"}
                      fullWidth
                      onClick={handlePreScreenQuestionEdit}
                      disabled={resumeLoader}
                      svg={true}
                    />
                  </Fragment>
                ) : (
                  <CommonButton
                    variant="outlined"
                    color="#344054"
                    border="transparent"
                    startIcon={<AddIco sx={{ color: "#7F56D9" }} />}
                    fontWeight="700"
                    value={"Add Question"}
                    gap={"0px"}
                    padding={"4px 1rem"}
                    fullWidth
                    onClick={handlePreScreenQuestionEdit}
                    disabled={resumeLoader}
                    svg={true}
                  />
                )}
              </CommonGrid2>
            )}
          </CommonGrid2>

          {resumeLoader ? (
            <HandleSkeletion width="100%" height="50px" />
          ) : (
            check_validation && (
              <CustomOrderList
                padding="0px 0px 0px 25px"
                margin="10px 0px"
                gap="10px"
                fontSize="15px"
              >
                {/* {matchedData?.insights?.feedback?.pres_screen_questions?.map(
                  (item, index) => (
                    <li> {item}</li>
                  )
                )} */}
                {matchedData?.insights?.feedback?.pre_screen_questions_red_flags?.map(
                  (item, index) => (
                    <li key={index}>
                      {item.text}{" "}
                      {item.include_in_coversheet && (
                        <TickTalairoIco
                          style={{
                            position: "relative",
                            top: "2px",
                            right: "-2px",
                          }}
                        />
                      )}
                    </li>
                  )
                )}
              </CustomOrderList>
            )
          )}
        </CustomDiv>
      </CustomPaper>
    </Fragment>
  );
}
